import {useMutation} from "@tanstack/react-query";
import {notification} from "antd";
import {useTranslation} from "react-i18next";
import {postUserRegistrationSimplified} from "../services/account/registerUserSimplified.service";
import {useAuthStore} from "../store/useAuth.store";
import useGetAppConfig from "./useGetAppConfig";

const useUserRegistration = () => {
  const {t} = useTranslation();
  const login = useAuthStore(state => state.login);
  const {refetch: refetchAppConfig} = useGetAppConfig();

  const {isPending, mutate, isSuccess, error} = useMutation({
    mutationFn: postUserRegistrationSimplified,
    onError: _error => {
      // Error handling is now done in the component
    },
    onSuccess: response => {
      // Validate response structure
      if (!response?.data?.data?.access_token) {
        notification.error({
          message: t("registrationError"),
          description:
            t("registrationErrorMessage") || "Registration completed but login failed. Please try logging in.",
        });
        return;
      }

      // Show success notification
      notification.success({
        message: t("registrationSuccessTitle") || "Registration Successful",
        description: t("registrationSuccessMessage") || "Welcome! You've been automatically logged in.",
        duration: 4,
        closable: true,
      });

      // Automatically log in the user with the received tokens
      login({data: response.data.data});

      // Refetch app config to load user-specific data
      refetchAppConfig();
    },
  });

  return {mutate, isPending, isSuccess, error};
};

export default useUserRegistration;
